import * as React from "react";
import { FC } from "react";
import SvgIcon from "material-ui/SvgIcon";

interface IProps {
    width?: number;
    height?: number;
    color?: string;
    className?: string;
}

export const PauseIcon: FC<IProps> = (props) => {
    return (
        <SvgIcon viewBox="0 0 136 136" {...props}>
            <g fill="none" fillRule="evenodd">
                <circle id="Oval" fillOpacity="0.9" fill="#FFFFFF" cx="68" cy="68" r="68" />
                <path
                    d={`
                        M58,36 C59.1045695,36 60,36.8954305 60,38 L60,98 C60,99.1045695 59.1045695,100 58,100 L46,100
                        C44.8954305,100 44,99.1045695 44,98 L44,38 C44,36.8954305 44.8954305,36 46,36 L58,36 Z M90,36
                        C91.1045695,36 92,36.8954305 92,38 L92,98 C92,99.1045695 91.1045695,100 90,100 L78,100 C76.8954305,100
                        76,99.1045695 76,98 L76,38 C76,36.8954305 76.8954305,36 78,36 L90,36 Z
                    `}
                    id="Combined-Shape"
                    fill="#585858"
                />
            </g>
        </SvgIcon>
    );
};
